import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/styles";
import React, { useRef, useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import MUIDataTable from "mui-datatables";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import apiService from "../service/apiService";
import { getBoAccountStatusDesc } from "./KycBoidModel";
import { formatDate } from "../other/adBsDatePicker";

const getMatchCriteria = (boidAnalysis, boid, isCompany) => {
  if (boidAnalysis.per100Minor && boidAnalysis.per100Minor.includes(boid))
    return 'Name, DOB and Minor Birth Certificate';
  else if (boidAnalysis.per100 && boidAnalysis.per100.includes(boid))
    return isCompany || (!boidAnalysis.fatherName) ? 'Company name/Reg No/PAN' : 'Name, Family Detail, DOB and Citizenship(No)';
  else if (boidAnalysis.per100nCtznDob && boidAnalysis.per100nCtznDob.includes(boid))
    return 'Name, DOB and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per100FLNameCtznDob && boidAnalysis.per100FLNameCtznDob.includes(boid))
    return 'First Name, Last Name, DOB and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per100AllNameDobCtzn19 && boidAnalysis.per100AllNameDobCtzn19.includes(boid))
    return 'Name, Family Detail, DOB and Citizenship(Dst-No)';
  else if (boidAnalysis.per90NDobCtzn19 && boidAnalysis.per90NDobCtzn19.includes(boid))
    return 'Name, DOB and Citizenship(Dst-No)';
  else if (boidAnalysis.per90AllNameDob && boidAnalysis.per90AllNameDob.includes(boid))
    return 'Name, Family Detail and DOB';
  else if (boidAnalysis.per90AllNameCtzn && boidAnalysis.per90AllNameCtzn.includes(boid))
    return 'Name, Family Detail and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per90AllNameCtzn19 && boidAnalysis.per90AllNameCtzn19.includes(boid))
    return 'Name, Family Detail and Citizenship(Dst-No)j';
  else if (boidAnalysis.per90AllNameCtzn15 && boidAnalysis.per90AllNameCtzn15.includes(boid))
    return 'Name, Family Detail and Citizenship(No)';
  else if (boidAnalysis.per90CtznDob && boidAnalysis.per90CtznDob.includes(boid))
    return 'DOB and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per90NameCtzn && boidAnalysis.per90NameCtzn.includes(boid))
    return 'Name and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per90FLNameCtzn && boidAnalysis.per90FLNameCtzn.includes(boid))
    return 'First name, Last name and Citizenship(Dst-No-Yr)';
  else if (boidAnalysis.per100Ctzn && boidAnalysis.per100Ctzn.includes(boid))
    return 'Citizenship(Dst-No-Yr)';
  else return null;
}

function ViewConflictData(props) {
  const [displayModal, setDisplayModal] = useState(true);
  const { t } = useTranslation();
  const [responseDataList, setResponseDataList] = useState([]);
  const [districtList, setDistrictList] = useState();
  useEffect(() => {
    apiService.getDistrictList().then((response) => {
      console.log(response);
      setDistrictList(response.data.data);
    });
  }, [])



  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "vertical",
    tableBodyMaxHeight: "",
    width: 800,
    tableBodyMaxHeight: '400px',
    fixedHeader: true,
    selectToolbarPlacement: "none",
    selectableRowsHideCheckboxes: true,
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    setRowProps: row => {
      console.log('rowcheck', row);
      if (!row[0] || row[0] === props.mainBoId)
        return {
          style: { background: "#efffef" }
        };
    }
  };

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  const getCitzenshipDetail = (c23, c19, c15) => {
    const data = c23 || c19 || c15;
    if (!data) return '';
    const list = [(c23 || c19) && data.substring(0, 4),
    data.substring((c23 || c19) ? 4 : 0, (c23) ? data.length - 4 : data.length),
    c23 && data.substring(data.length - 4, data.length)];
    list[0] = list.length && list[0] && getDescription(districtList, list[0]);
    return list.filter(d => d).join("-");
  }

  useEffect(() => {
    console.log('props.boids', props.boids);
    if (props.boids && districtList) {
      apiService.getDuplicateDataByBoids((typeof props.boids === 'string' ? props.boids.split(',') : props.boids).map(boid => boid.trim()).filter(boid => boid)).then(response => {
        const list = response.data.data.map(b => ({ ...b, ctznNo: getCitzenshipDetail(b.ctznNo23, b.ctznNo19, b.ctznNo15) }));
        if (props.mainBoId) {
          const mainBoidDetail = list.find(d => d.boId === props.mainBoId);
          list.filter(d => d.boId !== props.mainBoId).forEach(d => {
            d.matchCriteria = getMatchCriteria(mainBoidDetail, d.boId, props.isCompany);
          })
        }
        if (props.compareObject) list.push(props.compareObject);

        setResponseDataList(list);
      });
    }
  }, [props.boids && props.boids.length, districtList && districtList.length])

  const hideModal = () => {
    setDisplayModal(false);
  };

  const toast = useRef();

  const renderFooter = () => {
    return (
      <>
        <Button
          label="Close"
          icon="pi pi-times"
          onClick={props.onHide}
          className="p-button-text"
        />
      </>
    );
  };

  return (
    <div className="dialog">
      <div id="duplicateBoidData" className="card">
        <Toast ref={toast} />

        <Dialog
          header={t("duplicateBoidData")}
          visible={props.visible || displayModal}
          style={{ width: "100%", height: "550px" }}
          footer={renderFooter}
          onHide={props.onHide || hideModal}
        >

          <ThemeProvider theme={createTheme()}>
            <MUIDataTable
              data={responseDataList}
              columns={[{
                name: "boId",
                label: "BO ID",
              },
              {
                name: "custName",
                label: "Name",
              }, {
                name: "fatherName",
                label: "Father Name",
                options: {
                  display: !props.isCompany
                },
              },
              {
                name: "grandFatherName",
                label: "Grand Father Name",
                options: {
                  display: !props.isCompany
                },
              },
              {
                name: "dob",
                label: "Date of Birth/Incorporation",
                options: {
                  customBodyRender: (value) => {
                    return value ? formatDate(value) : String(value);
                  }, // Convert to string
                },
              },
              {
                name: "ctznNo",
                label: "Citizenship No",
                options: {
                  display: !props.isCompany
                },
              },
              {
                name: "birthCertificateNo",
                label: "Birth Certificate No",
                options: {
                  display: !props.isCompany
                },
              },
              {
                name: "email",
                label: "Email",
              }, {
                name: "mobile",
                label: "Mobile No",
              }, {
                name: "pan",
                label: "PAN",
              }, {
                name: "regNo",
                label: "Reg No",
                options: {
                  display: props.isCompany == null || props.isCompany
                },
              },
              {
                name: "acctSts",
                label: "BO Status",
                options: { customBodyRender: getBoAccountStatusDesc },
              },
              {
                name: "matchCriteria",
                label: "Match Criteria"
              }
              ]}
              options={options}
              style={{ height: 'none' }}
            />
          </ThemeProvider>
        </Dialog>
      </div>
    </div>
  );
}

export default ViewConflictData;
